import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { CommandPaletteSearchResult } from "components/CommandPalette/types";

import { SEARCH_STACKS_FOR_NAVIGATION, SearchStacksForNavigationItem } from "./gql";

type UseStackSearchForNavigationProps = {
  query: string;
};

const useStackSearchForNavigation = ({
  query,
}: UseStackSearchForNavigationProps): CommandPaletteSearchResult<SearchStacksForNavigationItem> => {
  const { data, previousData, loading } = useQuery(SEARCH_STACKS_FOR_NAVIGATION, {
    variables: {
      input: {
        after: null,
        first: 10,
        fullTextSearch: query,
        orderBy: null,
        requestedPage: null,
        predicates: [],
      },
    },
  });

  const stacks = useMemo(() => {
    return (
      data?.searchStacks?.edges.map((edge) => edge.node) ||
      previousData?.searchStacks?.edges.map((edge) => edge.node) ||
      []
    );
  }, [data, previousData]);

  return {
    items: stacks,
    loading,
    hasMore: !!data?.searchStacks?.pageInfo.hasNextPage,
    isEmpty: stacks.length === 0,
  };
};

export default useStackSearchForNavigation;
